import { ShippingContent } from "../../types/interfaces";
import { useMemo } from "react";

const ShippingHistory = ({ shippings }: { shippings: ShippingContent[] }) => {
  const sortedShippings = useMemo(() => {
    return [...shippings].sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
  }, [shippings]);

  return (
    <ul>
      {sortedShippings
        .filter(
          (shippingContent: ShippingContent) =>
            shippingContent.shipping.trackingNumber
        )
        .map(shippingContent => (
          <li key={shippingContent.id}>
            {new Date(shippingContent.createdAt).toLocaleDateString()}:{" "}
            {shippingContent.shipping.trackingNumber}
          </li>
        ))}
    </ul>
  );
};

export default ShippingHistory;
